import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { HeroLayout } from '@primer/gatsby-theme-doctocat';
import { Box as PRCBox } from '@primer/react';
import { Link, Button, Heading, Text } from '@primer/react-brand';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = HeroLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PRCBox sx={{
      p: 5,
      mt: 5
    }} mdxType="PRCBox">
  <Heading as="h4" mdxType="Heading">Primer Brand</Heading>
  <Text as="p" mdxType="Text">Read the installation instructions to get started.</Text>
  <PRCBox sx={{
        mt: 4,
        flexDirection: 'row',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'stretch',
        columnGap: '0.75rem'
      }} mdxType="PRCBox">
    <p>
      <Button as="a" variant="primary" href="/brand/getting-started" mdxType="Button">
        Installation instructions
      </Button>
    </p>
    <p>
      <Button as="a" variant="secondary" href="/brand/storybook" target="_blank" mdxType="Button">
        Storybook
      </Button>
    </p>
    <p>
      <Button as="a" variant="secondary" href="https://github.com/primer/brand" target="_blank" mdxType="Button">
        Contribute
      </Button>
    </p>
  </PRCBox>
    </PRCBox>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      